import { createContext, useContext } from 'react';
import { CUSTOMER_ROOT_DOMAIN } from '../../lib/domains';

// Build-time fallback until the authenticated API capability is available.
// App supplies the effective policy, including the administrator exception.
export const SelfServiceCreationContext = createContext(import.meta.env.VITE_SELF_SERVICE_CREATION_ENABLED === 'true' || (import.meta.env.VITE_SELF_SERVICE_CREATION_ENABLED !== 'false' && CUSTOMER_ROOT_DOMAIN !== 'protopal.ai'));
export const useSelfServiceCreation = () => useContext(SelfServiceCreationContext);
